export const hasException = (exceptions) => {
  return exceptions.some(exception => window.location.pathname === exception);
};

export const exceptions = ['/affiliates/'];

export default {
  pages: [
    {
      text: 'Latest',
      href: '/latest/'
    },
    {
      text: 'Lifestyle',
      href: '/lifestyle/'
    },
    {
      text: 'Travel',
      href: '/travel/'
    },
    {
      text: 'Influencers',
      href: '/influencers/'
    },
    {
      text: 'Exchange',
      type: 'external',
      href: 'https://exchange.furlough.com'
    }
    // {
    //   text: 'Brands',
    //   href: '/brands/'
    // }
  ],
  social: [
    {
      icon: 'twitter',
      href: 'https://twitter.com/furloughgroup'
    },
    {
      icon: 'facebook',
      href: 'https://facebook.com/furloughgroup'
    },
    {
      icon: 'instagram',
      href: 'https://instagram.com/furlough'
    },
    {
      icon: 'linkedin',
      href: 'https://www.linkedin.com/company/furlough'
    }
  ]
};
